import React, { useCallback } from 'react';
import timetableStructureTree from '../../../../modules/LMSAdmin/Timetable/data/timetableStructureTree.graphql';
import { isProgram, resolveNodeClassName, resolveNodeId, resolveNodeParentId, resolveNodeTitle, } from '../../../../modules/LMSAdmin/Timetable/data/useTimetableStructureTree';
import { useTranslation } from '../../utils/Translations';
import GqlStaticTreeSelector from './GqlStaticTreeSelector';
import { isRootNode } from '../../dataViews/DynamicTree';
import Button from '../Button';
const ScheduleProgramSelector = ({ value, onChange, timetableId }) => {
    const { t } = useTranslation();
    const _resolveNodeParentId = useCallback((node) => resolveNodeParentId([], node), []);
    const _resolveNodeTitle = useCallback((node) => resolveNodeTitle(t, null, node), [t]);
    const renderNodeAddons = (node, meta) => {
        const { handleClear } = meta;
        const handleClearFn = e => {
            handleClear();
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        };
        const addons = [];
        if (isRootNode(node)) {
            addons.push(<Button additionClasses="text-primary no-padding-top no-padding-bottom" buttonStyle="link" onClick={handleClearFn}>
          {t('Clear')}
        </Button>);
        }
        return addons;
    };
    return (<GqlStaticTreeSelector hasSyntheticRootNode isSingleSelector adapter={{
        renderNodeAddons,
        resolveNodeId,
        resolveNodeClassName,
        nodeIsLeaf: isProgram,
        resolveNodeParentId: _resolveNodeParentId,
        resolveNodeTitle: _resolveNodeTitle,
    }} gql={timetableStructureTree} gqlVariables={{
        id: timetableId,
    }} hasClearButton={false} name="ScheduleProgramSelector" plugins={{
        nodeIsSelectable: isProgram,
    }} syntheticRootNodeName={t('Program')} title={t('Program')} value={value} onChange={onChange}/>);
};
export default ScheduleProgramSelector;
